import script from "./LearnerWorkpacketGuidedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LearnerWorkpacketGuidedPage.vue?vue&type=script&setup=true&lang=js"

import "./LearnerWorkpacketGuidedPage.vue?vue&type=style&index=0&id=ca3ceff6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca3ceff6"]])

export default __exports__